import { render, staticRenderFns } from "./verification-failure.vue?vue&type=template&id=826189a2"
import script from "./verification-failure.vue?vue&type=script&lang=js"
export * from "./verification-failure.vue?vue&type=script&lang=js"
import style0 from "./verification-failure.vue?vue&type=style&index=0&id=826189a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports